import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'
import { FIVE_MINUTES } from '@zet/utils/cacheTime'

export type CategoryFilterData = {
  key: string
  type: 'SUB_FILTER' | 'DROPDOWN' | 'QUICK_FILTER'
  displayText: string
  values?: {
    key: 'BRANDS'
    displayText: string
    isMultiSelect: boolean
    values?: {
      displayText: string
      key: string
    }[]
  }[]
}[]

export const getCategoryFilters = async ({
  queryKey: [_, categoryId, pageType, customerId],
}: {
  queryKey: string[]
}) => {
  const { data } = await zetApi.request<{ data?: CategoryFilterData }>({
    url: `variants/filters?pageType=${pageType}&categoryId=${categoryId}${
      customerId ? `&customerId=${customerId}` : ''
    }`,
    method: 'GET',
  })
  return data?.data
}

type UseCategoryFiltersProps = {
  pageType: 'RECOMMENDATION_PAGE' | 'BRAND_PRODUCT_CATEGORY_PAGE'
  categoryId: number
  customerId?: number
}

const useCategoryFilters = ({
  pageType,
  categoryId,
  customerId,
}: UseCategoryFiltersProps) => {
  return useQuery({
    queryKey: [
      'filters',
      categoryId?.toString() || '',
      pageType?.toString() || '',
      customerId?.toString() || '',
    ],
    queryFn: getCategoryFilters,
    cacheTime: FIVE_MINUTES,
    staleTime: FIVE_MINUTES,
  })
}

export default useCategoryFilters
